import { getEmailAuthRedirectTo } from "@/lib/authRedirect";
import { requireSupabase } from "@/lib/supabase";

export async function sendPasswordResetToEmail(email: string): Promise<{ ok: true } | { ok: false; message: string }> {
  const trimmed = email.trim().toLowerCase();
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
    return { ok: false, message: "Enter a valid email address." };
  }
  try {
    const sb = requireSupabase();
    const { error } = await sb.auth.resetPasswordForEmail(trimmed, { redirectTo: getEmailAuthRedirectTo() });
    if (error) return { ok: false, message: error.message };
    return { ok: true };
  } catch (e) {
    return { ok: false, message: e instanceof Error ? e.message : "Could not send the email." };
  }
}
